import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import { withRouter } from 'react-router-dom';

import { APIgetShares } from '../api/Shares';

import SharesHeader from '../components/Shares/Header';
import SharesList from '../components/Shares/List';
import SharesFooter from '../components/Shares/Footer';
import SharesFilters from '../components/Shares/Filters';
import EmptyShareLinks from './EmptyContainers/ShareLinks';

import { getVisibleItemsText } from '../helpers';
import { userIsAdmin } from '../helpers/Auth';
import { getUserSetting } from '../helpers/Settings';
import { handleURLParams, handleComponentParams } from '../helpers/URLParams';

import Loading from '../components/Loading';
import ErrorBoundary from '../components/ErrorBoundary';

class Shares extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shares: [],
      sharesTotal: 0,
      users: [],
      selectedUser: null,
      defaultSelectedUser: null,
      scope: 'by_user',
      search: '',
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      orderBy: 'created_at',
      order: 'desc',
      loading: true,
    };

    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangePerPage = this.handleChangePerPage.bind(this);
    this.handleChangeUser = this.handleChangeUser.bind(this);
    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleSubmitSearch = this.handleSubmitSearch.bind(this);
    this.handleResetSearch = this.handleResetSearch.bind(this);
    this.afterEditShare = this.afterEditShare.bind(this);
    this.loadShares = this.loadShares.bind(this);
  }

  componentDidMount() {
    const { history, location } = this.props;
    const { orderBy, order } = this.state;
    const queryParams = new URLSearchParams(location.search);

    handleComponentParams(
      true,
      ['page', 'perPage', 'user_uuid', 'search', 'orderBy', 'order'],
      null,
      this.setState.bind(this),
      this.handleAfterMount.bind(this),
      {
        perPage: getUserSetting('admin_per_page') || 20,
        orderBy: 'created_at',
        order: 'desc',
      },
    );

    if (!queryParams.get('orderBy')) {
      handleURLParams({ orderBy }, history);
    }

    if (!queryParams.get('order')) {
      handleURLParams({ order }, history);
    }
  }

  componentDidUpdate(prevProps) {
    handleComponentParams(
      false,
      ['page', 'perPage', 'user_uuid', 'search', 'orderBy', 'order'],
      prevProps,
      this.setState.bind(this),
      this.loadShares.bind(this),
      {
        perPage: getUserSetting('admin_per_page') || 20,
        orderBy: 'created_at',
        order: 'desc',
      },
    );
  }

  handleAfterMount({ user_uuid: userUUID }) {
    if (userUUID) {
      const user = { uuid: userUUID };
      this.setState({ defaultSelectedUser: user });
      this.loadShares({ user_uuid: userUUID });
    } else if (!userIsAdmin()) {
      this.loadShares();
    } else {
      const { profile } = this.props;
      this.setState({ defaultSelectedUser: profile });
    }
  }

  loadShares({ user_uuid: userUUID } = { user_uuid: null }) {
    const {
      page,
      perPage,
      orderBy,
      order,
      selectedUser,
      scope,
      search,
    } = this.state;

    this.setState({ loading: true });

    const selectedUserUUID = userUUID || (selectedUser ? selectedUser?.uuid : null);

    APIgetShares({
      user_uuid: selectedUserUUID,
      scope,
      search,
      page,
      per_page: perPage,
      order_by: orderBy,
      order,
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          loading: false,
          shares: data.data,
          sharesTotal: data.meta.total,
          sharesGlobal: data.meta.total_global,
        });
      }
    });
  }

  handleChangePage(page) {
    const { history } = this.props;
    handleURLParams({ page }, history);

    this.setState({ page });
  }

  handleChangePerPage(perPage) {
    const { history } = this.props;
    handleURLParams({ perPage, page: 1 }, history);

    this.setState({ perPage, page: 1 });
  }

  handleChangeUser(user) {
    const { history } = this.props;
    const { selectedUser, defaultSelectedUser, page } = this.state;
    const isInitialDefaultSelection = !selectedUser && defaultSelectedUser && user
    && defaultSelectedUser.uuid === user.uuid;
    const effectivePage = isInitialDefaultSelection ? page : 1;

    handleURLParams({ user_uuid: user ? user.uuid : null, page: effectivePage }, history);

    this.setState({
      selectedUser: user,
      page: effectivePage,
    });
  }

  handleChangeSearch(e) {
    const { value: search } = e.target;

    this.setState({ search });
  }

  handleSubmitSearch() {
    const { history } = this.props;
    const { search } = this.state;
    handleURLParams({ search: search || null, page: 1 }, history);

    this.setState({ page: 1 });
  }

  handleResetSearch(e) {
    e.preventDefault();
    this.setState({ search: '' }, () => {
      this.handleSubmitSearch();
    });
  }

  handleChangeOrder(orderBy, order) {
    const { history } = this.props;
    handleURLParams({ orderBy, order, page: 1 }, history);

    this.setState({
      orderBy,
      order,
      page: 1,
    });
  }

  afterEditShare(share) {
    const { shares } = this.state;
    const shareIndex = shares.findIndex(ss => (ss.uuid === share.uuid));
    if (shareIndex >= 0) {
      shares[shareIndex] = share;
    }
    this.setState({ shares: [...shares] });
  }

  render() {
    const {
      selectedUser,
      defaultSelectedUser,
      scope,
      search,
      page,
      perPage,
      sharesTotal,
      loading,
    } = this.state;
    const { profile } = this.props;

    return (
      <div className="main-content shares-content">
        <Container fluid>
          <SharesHeader
            profile={profile}
            sharesTotal={sharesTotal}
            sharesVisible={getVisibleItemsText(page, perPage, sharesTotal)}
            loading={loading}
          />
          {(selectedUser || defaultSelectedUser) && (
            <SharesFilters
              loading={loading}
              selectedUser={selectedUser}
              defaultSelectedUser={defaultSelectedUser}
              scope={scope}
              search={search}
              sharesTotal={sharesTotal}
              handleChangeSearch={this.handleChangeSearch}
              handleSubmitSearch={this.handleSubmitSearch}
              handleResetSearch={this.handleResetSearch}
              handleChangeUser={this.handleChangeUser}
            />
          )}
          {loading ? (
            <Loading />
          ) : (
            <div className="content-wrapper">
              <ErrorBoundary>
                {(sharesTotal === 0 && !search) ? (
                  <EmptyShareLinks />
                ) : (
                  <SharesList
                    {...this.state}
                    profile={profile}
                    scope={scope}
                    handleChangeOrder={this.handleChangeOrder}
                    afterEditShare={this.afterEditShare}
                    loadShares={this.loadShares}
                  />
                )}
              </ErrorBoundary>
              <ErrorBoundary>
                <SharesFooter
                  {...this.state}
                  handleChangePage={this.handleChangePage}
                  handleChangePerPage={this.handleChangePerPage}
                />
              </ErrorBoundary>
            </div>
          )}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

Shares.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
};

export default withRouter(connect(mapStateToProps)(Shares));
